import { ValuationsCapTableWarningsMenu } from '@dealstack/frontend/app/pages/Valuations/components/ValuationsWarnings/ValuationsCapTableWarningsMenu.tsx';
import { ValuationsValidationWarningsMenu } from '@dealstack/frontend/app/pages/Valuations/components/ValuationsWarnings/ValuationsValidationWarningsMenu';
import { ValuationsValidationError } from '@dealstack/frontend/app/pages/Valuations/components/ValuationsWarnings/ValuationsWarnings.utils';
import { useValuationNavigation } from '@dealstack/frontend/app/pages/Valuations/hooks/useValuationNavigation';
import { ValuationLocation } from '@dealstack/frontend/app/pages/Valuations/shared/valuationRoutes';
import { OverdistributionErrorSourceEnum } from '@dealstack/shared/lib/generated';
import { useContext } from 'react';
import { DealContext } from '@dealstack/frontend/app/pages/Project/DealDashboard/DealContext';

interface ValuationsWarningsProps {
	validationErrors?: ValuationsValidationError[];
	isSummaryLoading?: boolean;
}

export function ValuationsWarnings({
	validationErrors = [],
	isSummaryLoading = false,
}: ValuationsWarningsProps) {
	const { navigateTo, dealId, pathValuationId, currentLocation } = useValuationNavigation();
	const { isAllTransactionValidInDeal, capDetailsIsLoading } = useContext(DealContext);

	const shouldShowValuationValidationWarnings =
		validationErrors.length > 0 &&
		!(
			currentLocation === ValuationLocation.SPECIFIC ||
			currentLocation === ValuationLocation.ROOT
		);

	if (!isAllTransactionValidInDeal && !capDetailsIsLoading) {
		return <ValuationsCapTableWarningsMenu />;
	}

	if (shouldShowValuationValidationWarnings && !isSummaryLoading) {
		return (
			<ValuationsValidationWarningsMenu
				errors={validationErrors}
				navigateToError={({ personId, mipId, sourceType }) => {
					if (!dealId || !pathValuationId) {
						return;
					}

					const payload = {
						dealId: dealId ?? '',
						valuationId: pathValuationId ?? '',
						personId,
						mipId,
					};

					if (
						sourceType === OverdistributionErrorSourceEnum.SOURCES ||
						sourceType === OverdistributionErrorSourceEnum.USES
					) {
						navigateTo(ValuationLocation.SOURCES_AND_USES, payload);
					} else if (sourceType === OverdistributionErrorSourceEnum.OVERRIDES) {
						navigateTo(ValuationLocation.BREAKPOINT_SUMMARY, payload);
					}
				}}
			/>
		);
	}

	return null;
}
